module.exports = __webpack_public_path__ + "img/clip.a449e887.svg";